import React from "react";
import "./home.scss";

export const HomeScreen = () => {
  return (
    <div>
      <h1 className="home-header">Bienvenido a medicines app</h1>

      <p>Gestiona los medicamentos de tu familia</p>
    </div>
  );
};
